import { McpChatWidgetElement } from './McpChatWidgetElement';

if (!customElements.get('mcp-chat-widget')) {
  customElements.define('mcp-chat-widget', McpChatWidgetElement);
}
